import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { SharedService } from "src/app/shared/serviceLayer/shared.service";

@Injectable()

export class UserService {

    url: any = environment.API_URL;

    constructor(
        private http: HttpClient,
        private sharedService: SharedService
    ) {

    }

    getUserInfo(data: any) {
        return this.http.get(this.url + 'user/me', data);
    }

    changeUserType(data: any) {
        return this.http.patch(this.url + 'user/ur-raw', data);
    }

    getSalesman(data: any) {
        return this.http.get(this.url + 'user/salesman', data);
    }

    updateUser(data: any) {
        return this.http.patch(this.url + 'user/update', this.sharedService?.newEncryptJson(data));
    }
    
    branchList(data: any) {
        return this.http.post(this.url + 'master/branch-list', data);
    }

    getUserQueriesListById(postData: any) {
        return this.http.get<any>(`${this.url}contact-us/buyerQueries/${postData?.userId}`);
    }

    //no more use below api
    getsssUserTickets(postData: any) {
        return this.http.get<any>(`${this.url}contact-us/ticket?${postData}`);
    }

    assignTicketToUser(id: any, data: any) {
        return this.http.patch(`${this.url}contact-us/ticket/${id}`, data);
    }

    getTicektComments(data: any) {
        return this.http.get(`${this.url}contact-us/getTicektComments?${data}`,);
    }

    getUserList(data: any) {
        return this.http.post(this.url + 'user/list', data);
    }

    registerUser(data: any) {
        return this.http.post(this.url + 'user/register', data);
    }

    userRoleList(data: any) {
        return this.http.post(this.url + 'user/role-list', data);
    }

}
